import { createSlice } from '@reduxjs/toolkit';
import { credentialsUpdated, sessionCleared, type UserProfile } from '@/shared/lib/redux/actions';

export type AuthStatus = 'idle' | 'authenticated' | 'unauthenticated';

export interface AuthState {
  accessToken: string | null;
  user: UserProfile | null;
  status: AuthStatus;
}

const initialState: AuthState = {
  accessToken: null,
  user: null,
  status: 'idle',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(credentialsUpdated, (state, action) => {
        state.accessToken = action.payload.accessToken;
        state.user = action.payload.user;
        state.status = 'authenticated';
      })
      .addCase(sessionCleared, (state) => {
        state.accessToken = null;
        state.user = null;
        state.status = 'unauthenticated';
      });
  },
});

export const authReducer = authSlice.reducer;
